(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[405],{

/***/ 8312:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/",
      function () {
        return __webpack_require__(3143);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 3143:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ pages; }
});

// EXTERNAL MODULE: ./node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(5944);
// EXTERNAL MODULE: ./src/components/Footer/Footer.tsx + 1 modules
var Footer = __webpack_require__(54);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 2 modules
var emotion_styled_browser_esm = __webpack_require__(6829);
;// CONCATENATED MODULE: ./src/components/Hero/Hero.styled.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  min-height: 100vh;\n  width: 100%;\n  background: radial-gradient(\n    108.12% 88.53% at 101.6% -1.99%,\n    #17557d 0.52%,\n    #070a1e 100%\n  );\n  overflow: hidden;\n  position: relative;\n  padding-bottom: 32px;\n\n  ",
        " {\n    padding-bottom: 64px;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-top: 24px;\n  position: absolute;\n  top: 92px;\n  left: 0;\n  z-index: 0;\n\n  ",
        " {\n    display: none;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  z-index: 3;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background-image: url('images/map.svg');\n  background-repeat: no-repeat;\n  background-size: cover;\n  background-position: center;\n\n  ",
        " {\n    display: none;\n  }\n\n  &:before {\n    content: '';\n    left: 0;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    position: absolute;\n    background: linear-gradient(\n      90deg,\n      #070a1e 0%,\n      rgba(39, 39, 39, 0) 50.52%,\n      rgba(7, 10, 30, 0.6) 100%\n    );\n    opacity: 0.3;\n  }\n\n  &:after {\n    content: '';\n    left: 0;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    position: absolute;\n    background: linear-gradient(\n        180deg,\n        rgba(0, 0, 0, 0) 56.25%,\n        rgba(0, 0, 0, 0.2) 82.81%\n      ),\n      rgba(7, 10, 30, 0.4);\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}

var StyledHero = emotion_styled_browser_esm/* default.div */.Z.div(_templateObject(), function(props) {
    return props.theme.breakpoints.up("md");
});
var StyledLinesWrapper = emotion_styled_browser_esm/* default.div */.Z.div(_templateObject1(), function(props) {
    return props.theme.breakpoints.down("md");
});
var StyledContent = emotion_styled_browser_esm/* default.div */.Z.div(_templateObject2());
var StyledMapWrapper = emotion_styled_browser_esm/* default.div */.Z.div(_templateObject3(), function(props) {
    return props.theme.breakpoints.down("md");
});

// EXTERNAL MODULE: ./src/components/Container/Container.tsx + 1 modules
var Container = __webpack_require__(883);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Typography/Typography.js + 1 modules
var Typography = __webpack_require__(9630);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(7568);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(655);
// EXTERNAL MODULE: ./node_modules/@mui/lab/LoadingButton/LoadingButton.js + 8 modules
var LoadingButton = __webpack_require__(7271);
;// CONCATENATED MODULE: ./src/components/Button/Button.styled.ts

function Button_styled_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  padding: 0 24px;\n  height: 48px;\n  background: ",
        ";\n  box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.25);\n  font-size: 16px;\n  font-weight: 600;\n  font-family: 'General Sans';\n  color: white;\n  text-transform: none;\n  border-radius: 0;\n  transition: background 350ms;\n\n  &:hover {\n    background: #2dc2b3;\n  }\n"
    ]);
    Button_styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var StyledButton = (0,emotion_styled_browser_esm/* default */.Z)(LoadingButton/* default */.Z)(Button_styled_templateObject(), function(props) {
    return props.disabled ? "#2ADDBA !important" : "#2ADDBA";
});

;// CONCATENATED MODULE: ./src/components/Button/Button.tsx

/* harmony default export */ var Button = (StyledButton);

;// CONCATENATED MODULE: ./src/components/Hero/Newsletter.styled.ts

function Newsletter_styled_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background: linear-gradient(\n    180deg,\n    rgba(7, 10, 30, 0.2) 0%,\n    rgba(7, 10, 30, 0) 34.38%,\n    rgba(7, 10, 30, 0) 64.58%,\n    rgba(7, 10, 30, 0.2) 100%\n  );\n  border: 1px solid #2addba;\n  padding: 48px 24px;\n  width: 100%;\n  box-sizing: border-box;\n\n  ",
        " {\n    padding: 32px 64px;\n  }\n"
    ]);
    Newsletter_styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var StyledNewsletter = emotion_styled_browser_esm/* default.div */.Z.div(Newsletter_styled_templateObject(), function(props) {
    return props.theme.breakpoints.up("md");
});

// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Stack/Stack.js
var Stack = __webpack_require__(9144);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Input/Input.js + 10 modules
var Input = __webpack_require__(9091);
;// CONCATENATED MODULE: ./src/components/Input/Input.styled.ts

function Input_styled_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        '\n  background: rgba(42, 221, 186, 0.16);\n  border: 1px solid #2ADDBA;\n  padding: 0 24px;\n  height: 48px;\'\n  font-family: "General Sans";\n  font-weight: 500;\n'
    ]);
    Input_styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var StyledInput = (0,emotion_styled_browser_esm/* default */.Z)(Input/* default */.Z)(Input_styled_templateObject());

;// CONCATENATED MODULE: ./src/components/Input/Input.tsx

/* harmony default export */ var Input_Input = (StyledInput);

// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Box/Box.js + 1 modules
var Box = __webpack_require__(1953);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_extends.mjs
var _extends = __webpack_require__(872);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(6042);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Checkbox/Checkbox.js + 8 modules
var Checkbox = __webpack_require__(3109);
;// CONCATENATED MODULE: ./src/components/Checkbox/Checkbox.styled.ts

function Checkbox_styled_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  border-radius: none;\n  padding: 0;\n  width: 22px;\n  height: 22px;\n  margin-top: 6px;\n\n  &:hover {\n    background: none;\n  }\n"
    ]);
    Checkbox_styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function Checkbox_styled_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 22px;\n  height: 22px;\n  background: rgba(42, 221, 186, 0.16);\n  border: 1px solid #2addba;\n"
    ]);
    Checkbox_styled_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function Checkbox_styled_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 22px;\n  height: 22px;\n  background: #2addba;\n  border: 1px solid #2addba;\n  color: white;\n"
    ]);
    Checkbox_styled_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}


var StyledCheckbox = (0,emotion_styled_browser_esm/* default */.Z)(Checkbox/* default */.Z)(Checkbox_styled_templateObject());
StyledCheckbox.defaultProps = {
    disableRipple: true
};
var StyledIcon = emotion_styled_browser_esm/* default.span */.Z.span(Checkbox_styled_templateObject1());
var StyledCheckedIcon = emotion_styled_browser_esm/* default.span */.Z.span(Checkbox_styled_templateObject2());

// EXTERNAL MODULE: ./node_modules/@mui/material/esm/utils/createSvgIcon.js + 2 modules
var createSvgIcon = __webpack_require__(8175);
;// CONCATENATED MODULE: ./src/theme/icons/assets/approve.svg
var _path;
var _excluded = ["title", "titleId"];
function approve_extends() { return approve_extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, approve_extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) { o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) { if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } } return t; }

var SvgApprove = function SvgApprove(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/react.createElement("svg", approve_extends({
    width: 22,
    height: 22,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/react.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/react.createElement("path", {
    d: "m4.583 11.917 3.233 2.586a1.833 1.833 0 0 0 2.508-.206l7.093-7.88",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
/* harmony default export */ var approve = (SvgApprove);
;// CONCATENATED MODULE: ./src/theme/icons/assets/discord.svg
var discord_path;
var discord_excluded = ["title", "titleId"];
function discord_extends() { return discord_extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, discord_extends.apply(null, arguments); }
function discord_objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = discord_objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) { o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } } return i; }
function discord_objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) { if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } } return t; }

var SvgDiscord = function SvgDiscord(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = discord_objectWithoutProperties(_ref, discord_excluded);
  return /*#__PURE__*/react.createElement("svg", discord_extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/react.createElement("title", {
    id: titleId
  }, title) : null, discord_path || (discord_path = /*#__PURE__*/react.createElement("path", {
    d: "M9.062 12.098a1.684 1.684 0 0 1-.076-.498c0-.836.633-1.638 1.566-1.638.697 0 1.243.453 1.462 1.044.218-.585.752-1.044 1.458-1.044.933 0 1.566.802 1.566 1.638a1.7 1.7 0 0 1-.088.538.75.75 0 0 1 .969.897l.047-.05a9.757 9.757 0 0 0-.532-2.809c-.07-.207-.141-.393-.207-.554a.748.748 0 0 1-.388-.092 5.771 5.771 0 0 0-3.566-.666.749.749 0 0 1-.073.006h-.002l-.014.002-.02.004a.746.746 0 0 1-.06.007c-.209.018-.804.105-1.573.441a9.489 9.489 0 0 0-.397.194l-.02.01-.003.002a.749.749 0 0 1-.239.082c-.066.164-.138.353-.21.564a9.755 9.755 0 0 0-.532 2.81c.033.037.073.079.122.123a.75.75 0 0 1 .81-1.011Zm0 0c.039.126.092.246.158.359l-.268.383m.429-.615Zm0 0h.001Zm-.429.615.374-.224a1.68 1.68 0 0 1-.106-.159l-.268.383Zm0 0-.363.519m7.123 5.503a.75.75 0 0 0 .58-.274l.478.442.013.012 1.72 1.52A.75.75 0 0 0 19.75 20V5.648a2.394 2.394 0 0 0-2.39-2.398H6.64a2.394 2.394 0 0 0-2.39 2.398v10.816a2.394 2.394 0 0 0 2.39 2.398h9.072Zm-3.088-5.883a4.852 4.852 0 0 1-1.193-.02c.267-.19.468-.463.581-.771.119.319.332.6.612.79Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })));
};
/* harmony default export */ var discord = (SvgDiscord);
;// CONCATENATED MODULE: ./src/theme/icons/assets/medium.svg
var medium_path;
var medium_excluded = ["title", "titleId"];
function medium_extends() { return medium_extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, medium_extends.apply(null, arguments); }
function medium_objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = medium_objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) { o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } } return i; }
function medium_objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) { if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } } return t; }

var SvgMedium = function SvgMedium(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = medium_objectWithoutProperties(_ref, medium_excluded);
  return /*#__PURE__*/react.createElement("svg", medium_extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/react.createElement("title", {
    id: titleId
  }, title) : null, medium_path || (medium_path = /*#__PURE__*/react.createElement("path", {
    d: "m5.206 8.465.03.031a.129.129 0 0 1 .014.036v6.801a.65.65 0 0 0 .027.184.646.646 0 0 0-.066.069l-1.7 1.944a.65.65 0 0 0-.161.428v.292c0 .359.291.65.65.65h4.7a.65.65 0 0 0 .65-.65v-.292a.65.65 0 0 0-.16-.427l-1.647-1.884c-.07-.14-.093-.208-.093-.314v-3.045l2.963 6.24A.65.65 0 0 0 11 18.9h.4a.65.65 0 0 0 .602-.405l2.348-5.77v3.792l-1.203 1.17a.65.65 0 0 0-.197.466v.291c0 .36.291.65.65.65h6.3a.65.65 0 0 0 .65-.65v-.291a.65.65 0 0 0-.197-.466l-1.103-1.073V7.838l1.184-1.063a.65.65 0 0 0 .216-.483V6a.65.65 0 0 0-.65-.65h-4.4a.65.65 0 0 0-.6.4l-2.635 6.324-2.976-6.35A.65.65 0 0 0 8.8 5.35H4.2a.65.65 0 0 0-.65.65v.292a.65.65 0 0 0 .156.423l1.5 1.75Z",
    stroke: "currentColor",
    strokeWidth: 1.3,
    strokeLinejoin: "round"
  })));
};
/* harmony default export */ var medium = (SvgMedium);
;// CONCATENATED MODULE: ./src/theme/icons/assets/telegram.svg
var telegram_path;
var telegram_excluded = ["title", "titleId"];
function telegram_extends() { return telegram_extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, telegram_extends.apply(null, arguments); }
function telegram_objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = telegram_objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) { o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } } return i; }
function telegram_objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) { if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } } return t; }

var SvgTelegram = function SvgTelegram(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = telegram_objectWithoutProperties(_ref, telegram_excluded);
  return /*#__PURE__*/react.createElement("svg", telegram_extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/react.createElement("title", {
    id: titleId
  }, title) : null, telegram_path || (telegram_path = /*#__PURE__*/react.createElement("path", {
    d: "m3.909 11.095 15.389-6.65a1 1 0 0 1 1.384 1.074l-2.104 13.276a1 1 0 0 1-1.715.53L13.53 15.77a2 2 0 0 1-.125-2.6l2.318-3.24c.14-.18-.08-.416-.27-.29l-4.846 3.253a4 4 0 0 1-2.801.637l-3.644-.527c-.998-.145-1.179-1.508-.253-1.908Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
/* harmony default export */ var telegram = (SvgTelegram);
;// CONCATENATED MODULE: ./src/theme/icons/assets/twitter.svg
var twitter_path;
var twitter_excluded = ["title", "titleId"];
function twitter_extends() { return twitter_extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, twitter_extends.apply(null, arguments); }
function twitter_objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = twitter_objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) { o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } } return i; }
function twitter_objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) { if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } } return t; }

var SvgTwitter = function SvgTwitter(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = twitter_objectWithoutProperties(_ref, twitter_excluded);
  return /*#__PURE__*/react.createElement("svg", twitter_extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/react.createElement("title", {
    id: titleId
  }, title) : null, twitter_path || (twitter_path = /*#__PURE__*/react.createElement("path", {
    d: "M15.286 4c-2.104 0-3.81 1.79-3.81 4 0 .334.04.658.113.968C9.3 8.968 5.7 8.444 3 4.888c0 8.89 3.6 11.408 5.4 11.556-1.35 1.334-3.454 2.32-5.4 2.506.837.76 3.46 1.017 4.667 1.05 6.241 0 11.314-5.253 11.426-11.778C20.29 7.444 20.86 5.334 21 4.89c-.583.612-1.8.889-2.77.573C17.532 4.569 16.472 4 15.286 4Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })));
};
/* harmony default export */ var twitter = (SvgTwitter);
;// CONCATENATED MODULE: ./src/theme/icons/index.ts







var createMaterialIcon = function(Icon) {
    return (0,createSvgIcon/* default */.Z)((0,react.createElement)(Icon), Icon.displayName || "SVGIcon");
};
var ApproveIcon = createMaterialIcon(approve);
var DiscordIcon = createMaterialIcon(discord);
var MediumIcon = createMaterialIcon(medium);
var TwitterIcon = createMaterialIcon(twitter);
var TelegramIcon = createMaterialIcon(telegram);

;// CONCATENATED MODULE: ./src/components/Checkbox/Checkbox.tsx






var Checkbox_Checkbox = function(_param) {
    var rest = (0,_extends/* default */.Z)({}, _param);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledCheckbox, (0,_object_spread/* default */.Z)({
        icon: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledIcon, {}),
        checkedIcon: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledCheckedIcon, {
            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ApproveIcon, {
                viewBox: "-5 -6 32 32"
            })
        })
    }, rest));
};
/* harmony default export */ var components_Checkbox_Checkbox = (Checkbox_Checkbox);

// EXTERNAL MODULE: ./node_modules/@mui/material/esm/useMediaQuery/useMediaQuery.js
var useMediaQuery = __webpack_require__(1225);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(9534);
// EXTERNAL MODULE: ./node_modules/@emotion/react/dist/emotion-react.browser.esm.js
var emotion_react_browser_esm = __webpack_require__(917);
;// CONCATENATED MODULE: ./src/components/LoadingSpinner/LoadingSpinner.styled.ts

function LoadingSpinner_styled_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  from {\n    transform: rotate(0deg);\n  }\n  to {\n    transform: rotate(359deg);\n  }\n"
    ]);
    LoadingSpinner_styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function LoadingSpinner_styled_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n        height: 36px;\n        width: 36px;\n        border-width: 5px;\n      "
    ]);
    LoadingSpinner_styled_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function LoadingSpinner_styled_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n        height: 10px;\n        width: 10px;\n      "
    ]);
    LoadingSpinner_styled_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function LoadingSpinner_styled_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n        height: 16px;\n        width: 16px;\n      "
    ]);
    LoadingSpinner_styled_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  border: ",
        ";\n  border-top: ",
        ";\n  border-radius: 50%;\n  animation: ",
        " 1s infinite linear;\n  ",
        "\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      min-height: calc(100vh - 70px) !important;\n      display: flex;\n      align-items: center;\n      justify-content: center;\n    "
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}


var spin = (0,emotion_react_browser_esm/* keyframes */.F4)(LoadingSpinner_styled_templateObject());
var getStylesBySize = function(size) {
    switch(size){
        case "large":
            return (0,emotion_react_browser_esm/* css */.iv)(LoadingSpinner_styled_templateObject1());
        case "small":
            return (0,emotion_react_browser_esm/* css */.iv)(LoadingSpinner_styled_templateObject2());
        case "medium":
        default:
            return (0,emotion_react_browser_esm/* css */.iv)(LoadingSpinner_styled_templateObject3());
    }
};
var StyledLoadingSpinner = emotion_styled_browser_esm/* default.div */.Z.div(_templateObject4(), function(props) {
    return props.color === "secondary" ? "3px rgba(255, 255, 255, 0.3) solid" : "3px #22bb85 solid";
}, function(props) {
    return props.color === "secondary" ? "3px #e8e8e8 solid" : "3px #214c3d solid";
}, spin, function(props) {
    return getStylesBySize(props.size || "medium");
});
var StyledLoadingSpinnerContainer = emotion_styled_browser_esm/* default.div */.Z.div(_templateObject6(), function(props) {
    return props.center && (0,emotion_react_browser_esm/* css */.iv)(_templateObject5());
});

;// CONCATENATED MODULE: ./src/components/LoadingSpinner/LoadingSpinner.tsx






var LoadingSpinner = function(_param) {
    var _addText = _param.addText, addText = _addText === void 0 ? false : _addText, _center = _param.center, center = _center === void 0 ? false : _center, rest = (0,_object_without_properties/* default */.Z)(_param, [
        "addText",
        "center"
    ]);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledLoadingSpinnerContainer, {
        center: center,
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Stack/* default */.Z, {
            direction: "row",
            alignItems: "center",
            spacing: 2,
            children: [
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledLoadingSpinner, (0,_object_spread/* default */.Z)({}, rest)),
                addText && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Typography/* default */.Z, {
                    variant: "body2",
                    color: "text.primary",
                    children: "Loading..."
                })
            ]
        })
    });
};
/* harmony default export */ var LoadingSpinner_LoadingSpinner = (LoadingSpinner);

;// CONCATENATED MODULE: ./src/components/Hero/Newsletter.tsx













var Newsletter = function() {
    var ref = (0,react.useState)(false), loading = ref[0], setLoading = ref[1];
    var ref1 = (0,react.useState)(null), success = ref1[0], setSuccess = ref1[1];
    var ref2 = (0,react.useState)({
        email: null,
        api: null,
        tosChecked: null
    }), errors = ref2[0], setErrors = ref2[1];
    var ref3 = (0,react.useState)(""), email = ref3[0], setEmail = ref3[1];
    var ref4 = (0,react.useState)(false), tosChecked = ref4[0], setTosChecked = ref4[1];
    var validate = function() {
        var regExp = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!email || !email.match(regExp)) {
            return {
                email: true
            };
        }
        if (!tosChecked) {
            return {
                tosChecked: true
            };
        }
        return {
            email: false,
            tosChecked: false
        };
    };
    var handleChange = function(e) {
        setEmail(e.target.value);
    };
    var handleSubmit = function(e) {
        e.preventDefault();
        if (validate().email) return setErrors({
            email: "There is an error in the email address you entered.",
            api: null,
            tosChecked: null
        });
        if (validate().tosChecked) {
            return setErrors({
                tosChecked: "Please read and accept our Terms of Service.",
                api: null,
                email: null
            });
        }
        setLoading(true);
        setTimeout(/*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
            var response, _tmp, _tmp1, _tmp2, error, ref, apiError, _tmp3;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            2,
                            ,
                            3
                        ]);
                        _tmp = {};
                        return [
                            4,
                            fetch("/api/subscribe", (_tmp.body = JSON.stringify({
                                email: email
                            }), _tmp.headers = {
                                "Content-Type": "application/json"
                            }, _tmp.method = "POST", _tmp))
                        ];
                    case 1:
                        response = _state.sent();
                        _tmp1 = {};
                        _tmp2 = {};
                        if (response.status === 500) {
                            setErrors((_tmp1.email = null, _tmp1.tosChecked = null, _tmp1.api = "Something went wrong. Please try again later.", _tmp1));
                        } else {
                            setErrors((_tmp2.email = null, _tmp2.api = null, _tmp2.tosChecked = null, _tmp2));
                            setSuccess("Thanks for signing up. We will keep you up to date with our project.");
                        }
                        return [
                            3,
                            3
                        ];
                    case 2:
                        error = _state.sent();
                        _tmp3 = {};
                        if (error === null || error === void 0 ? void 0 : error.response) {
                            ;
                            apiError = error === null || error === void 0 ? void 0 : (ref = error.response) === null || ref === void 0 ? void 0 : ref.data.error;
                            setErrors((_tmp3.email = null, _tmp3.tosChecked = null, _tmp3.api = apiError && apiError === "email-exists" ? "Looks like you've already subscribed, try a different email address." : "Something went wrong. Please try again later.", _tmp3));
                            setSuccess(null);
                        }
                        return [
                            3,
                            3
                        ];
                    case 3:
                        setEmail("");
                        setTosChecked(false);
                        setLoading(false);
                        return [
                            2
                        ];
                }
            });
        }), 1000);
    };
    var isMobile = (0,useMediaQuery/* default */.Z)(function(theme) {
        return theme.breakpoints.down("md");
    });
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(StyledNewsletter, {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Typography/* default */.Z, {
                variant: "h3",
                color: "text.primary",
                mb: 1,
                textAlign: "center",
                children: "Join community for Beta access"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Typography/* default */.Z, {
                variant: "body1",
                color: "text.primary",
                component: "p",
                mb: 4,
                textAlign: "center",
                children: "Sign up to our Newsletter and keep up to date with all things walnuts.farm!"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("form", {
                onSubmit: handleSubmit,
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Stack/* default */.Z, {
                        direction: {
                            xs: "column",
                            md: "row"
                        },
                        spacing: 2,
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Input_Input, {
                                sx: {
                                    width: "100%"
                                },
                                disableUnderline: true,
                                placeholder: "e-mail address",
                                value: email,
                                type: "email",
                                name: "email",
                                onChange: handleChange
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* default */.Z, {
                                minWidth: "170px",
                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* default */.Z, {
                                    minWidth: "170px",
                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Button, {
                                        variant: "contained",
                                        color: "primary",
                                        type: "submit",
                                        fullWidth: isMobile,
                                        loading: loading,
                                        disabled: loading,
                                        loadingIndicator: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LoadingSpinner_LoadingSpinner, {}),
                                        children: "Subscribe Now"
                                    })
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Stack/* default */.Z, {
                        direction: "row",
                        spacing: 2,
                        onClick: function() {
                            return setTosChecked(!tosChecked);
                        },
                        sx: {
                            cursor: "pointer"
                        },
                        mt: 4,
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(components_Checkbox_Checkbox, {
                                checked: tosChecked
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Typography/* default */.Z, {
                                variant: "body1",
                                color: "text.primary",
                                children: "I agree to the processing of personal data by WalNuts for marketing purposes and accept Terms of Service."
                            })
                        ]
                    }),
                    (errors.email || errors.api || errors.tosChecked) && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Typography/* default */.Z, {
                        variant: "body2",
                        color: "error.light",
                        mt: 1,
                        children: errors.email || errors.api || errors.tosChecked
                    }),
                    success && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Typography/* default */.Z, {
                        variant: "body2",
                        color: "primary",
                        mt: 1,
                        children: success
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var Hero_Newsletter = (Newsletter);

;// CONCATENATED MODULE: ./src/components/Hero/Hero.tsx








var Hero = function() {
    var isMobile = (0,useMediaQuery/* default */.Z)(function(theme) {
        return theme.breakpoints.down("md");
    });
    var prepareFormat = function(time) {
        if (time < 10) return "0" + time;
        else return time.toString();
    };
    var countDownDate = new Date(Date.UTC(2022, 8, 16, 16)).getTime();
    var ref = (0,react.useState)(0), days = ref[0], setDays = ref[1];
    var ref1 = (0,react.useState)("0"), hours = ref1[0], setHours = ref1[1];
    var ref2 = (0,react.useState)("0"), minutes = ref2[0], setMinutes = ref2[1];
    var countingDown = function() {
        var now = new Date().getTime();
        var timeleft = countDownDate - now;
        setDays(Math.floor(timeleft / (1000 * 60 * 60 * 24)));
        setHours(prepareFormat(Math.floor(timeleft % (1000 * 60 * 60 * 24) / (1000 * 60 * 60))));
        setMinutes(prepareFormat(Math.floor(timeleft % (1000 * 60 * 60) / (1000 * 60))));
    };
    (0,react.useEffect)(function() {
        countingDown();
        setInterval(countingDown, 10000);
    }, []);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(StyledHero, {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledLinesWrapper, {}),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledMapWrapper, {}),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Container/* default */.Z, {
                sx: {
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center"
                },
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(StyledContent, {
                    children: [
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* default */.Z, {
                            display: {
                                xs: "none",
                                md: "flex"
                            },
                            alignItems: "center",
                            justifyContent: "center",
                            mt: 2
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Typography/* default */.Z, {
                            variant: "h2",
                            color: "text.primary",
                            mt: 8,
                            textAlign: "center",
                            children: "Yor personal crypto trading companion"
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Typography/* default */.Z, {
                            variant: "h1",
                            color: "primary",
                            mb: {
                                xs: 8,
                                md: 3
                            },
                            textAlign: "center",
                            children: "Climb the WALL"
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Hero_Newsletter, {})
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ var Hero_Hero = (Hero);

;// CONCATENATED MODULE: ./pages/index.tsx



var Home = function() {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Hero_Hero, {}),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Footer/* default */.Z, {})
        ]
    });
};
/* harmony default export */ var pages = (Home);


/***/ }),

/***/ 883:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Container_Container; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 2 modules
var emotion_styled_browser_esm = __webpack_require__(6829);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Container/Container.js + 2 modules
var Container = __webpack_require__(6336);
;// CONCATENATED MODULE: ./src/components/Container/Container.styled.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  max-width: 1505px;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var StyledContainer = (0,emotion_styled_browser_esm/* default */.Z)(Container/* default */.Z)(_templateObject());

;// CONCATENATED MODULE: ./src/components/Container/Container.tsx

/* harmony default export */ var Container_Container = (StyledContainer);


/***/ }),

/***/ 54:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Footer_Footer; }
});

// EXTERNAL MODULE: ./node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(5944);
// EXTERNAL MODULE: ./src/components/Container/Container.tsx + 1 modules
var Container = __webpack_require__(883);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 2 modules
var emotion_styled_browser_esm = __webpack_require__(6829);
;// CONCATENATED MODULE: ./src/components/Footer/Footer.styled.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background: black;\n  padding: 74px 0;\n\n  ",
        " {\n    margin-top: 128px;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var StyledFooter = emotion_styled_browser_esm/* default.footer */.Z.footer(_templateObject(), function(props) {
    return props.theme.breakpoints.down("md");
});

// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Stack/Stack.js
var Stack = __webpack_require__(9144);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Typography/Typography.js + 1 modules
var Typography = __webpack_require__(9630);
;// CONCATENATED MODULE: ./src/components/Footer/Footer.tsx





var Footer = function() {
    var navLinks = [];
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledFooter, {
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Container/* default */.Z, {
            children: [
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Stack/* default */.Z, {
                    direction: {
                        xs: "column",
                        md: "row"
                    },
                    alignItems: {
                        md: "center"
                    },
                    justifyContent: "space-between",
                    spacing: {
                        xs: 4,
                        md: 0
                    },
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Stack/* default */.Z, {
                        direction: "row",
                        alignItems: "center",
                        spacing: 6,
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Typography/* default */.Z, {
                            variant: "body2",
                            sx: {
                                color: "rgba(255, 255, 255, 0.8) !important",
                                display: {
                                    xs: "none",
                                    md: "block"
                                }
                            },
                            children: [
                                "Copyright WALNUTS.FARM ",
                                new Date().getFullYear(),
                                ". All Rights Reserved."
                            ]
                        })
                    })
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Typography/* default */.Z, {
                    variant: "body2",
                    sx: {
                        color: "rgba(255, 255, 255, 0.8) !important",
                        display: {
                            md: "none"
                        }
                    },
                    mt: 4,
                    children: [
                        "Copyright WALNUTS.FARM ",
                        new Date().getFullYear(),
                        ". All Rights Reserved."
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var Footer_Footer = (Footer);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [668,579,774,888,179], function() { return __webpack_exec__(8312); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);